class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const cartItem = this.closest('.cart-item');
      if (cartItem.classList.contains('can-not-be-gift-wrapped')) {
        cartItems.updateQuantity(this.dataset.index, 0);
      } else if (cartItem.classList.contains('gift-wrap-product')){
        cartItems.clearGiftWrapFromCart(this.dataset.index);
      } else {
        const giftWrapLineItem = cartItems.querySelector('.gift-wrap-product');
        const normalProductLineItems = cartItems.querySelectorAll('.cart-item:not(.gift-wrap-product, .can-not-be-gift-wrapped)');
        if (normalProductLineItems.length == 1 && giftWrapLineItem) {
          cartItems.clearGiftWrapFromCart(this.dataset.index, normalProductLineItems[0]);
        } else {
          cartItems.updateQuantity(this.dataset.index, 0);
        }
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          // Dispatch custom event to reinitialize wishlist - Ailene WLC
          document.body.dispatchEvent(new CustomEvent('initTheWishlist', {
            detail: { source: 'cart-drawer' }
          }));
          // End of custom event dispatch
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;

          // Dispatch custom event to reinitialize wishlist - Ailene WLC
          document.body.dispatchEvent(new CustomEvent('initTheWishlist', {
            detail: { source: 'cart-drawer' }
          }));
          // End of custom event dispatch
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
        reInjectScripts: true,
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          if (!section.id || !document.getElementById(section.id)) return;
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if (section.reInjectScripts) {
            HTMLUpdateUtility.setInnerHTML(elementToReplace, elementToReplace.innerHTML);
          }
        });



        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);

        // Reinitialize wishlist event
        document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  clearGiftWrapFromCart(line, normalProductLineItem) {
    this.enableLoading(line);
    const updates = {};
    if (normalProductLineItem) {
      const normalProductLineItemId = normalProductLineItem.getAttribute('data-product-line-item-id');
      updates[normalProductLineItemId] = 0;
    }
    const giftWrapProductLineItem = document.querySelector('[data-gift-wrap-product-id]');
    if (giftWrapProductLineItem) {
      const giftWrapProductLineItemId = giftWrapProductLineItem.getAttribute('data-product-line-item-id');
      updates [giftWrapProductLineItemId] = 0
    }

    const attributes = {
      ['Gift Message']: null
    };

    const body = JSON.stringify({ updates, attributes, sections: this.getSectionsToRender().map((section) => section.section), sections_url: window.location.pathname});
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        if (!section.id || !document.getElementById(section.id)) return;

        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (section.reInjectScripts) {
          HTMLUpdateUtility.setInnerHTML(elementToReplace, elementToReplace.innerHTML);
        }
      });



      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
    })
    .catch(() => {
      this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.disableLoading(line);
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class GiftWrapComponent extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.giftWrapMessage = this.form.querySelector('[name="attributes[Gift Message]"]');
    this.emojiRegex = /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{2B55}\u{2934}\u{2935}\u{2B05}-\u{2B07}\u{2B1B}\u{2B1C}\u{2B50}\u{2B55}\u{3030}\u{303D}\u{3297}\u{3299}\u{1F004}\u{1F0CF}\u{1F170}-\u{1F251}]/gu;
    this.giftWrapMessageCounter = this.form.querySelector('.counter');
    this.addGiftWrapButton = document.getElementById('cart-flyout-add-gift-wrap');
    this.cartFlyoutGiftWrapClose = document.querySelector('.gift-wrap-cart-flyout .icon-close');
    this.cartFlyoutFooter = document.querySelector('.drawer__footer');
    this.cartFlyoutItems = document.querySelector('cart-drawer-items');
    this.cartFlyoutGiftWrap = document.querySelector('.gift-wrap-cart-flyout');
    this.cartFlyoutWrapper = document.querySelector('.drawer__inner');
    this.submitButton = this.form.querySelector('.add-gift-wrap-button');
    this.giftProducts = this.form.querySelectorAll('.gift-product');
  }

  connectedCallback() {
    this.form.addEventListener('submit', async (e) => {
      const giftWrapProductInCartId = this.getGiftWrapProductInCartId();
      const giftWrapIsExistingInCart = giftWrapProductInCartId != null;
      if (giftWrapIsExistingInCart) {
        e.preventDefault();
        const addingGiftWrapProductId = this.getAddingGiftWrapProductId();
        if (giftWrapProductInCartId == addingGiftWrapProductId) {
          const result = await this.updateGiftMessage();
          if (result) {
            window.location.href = routes.cart_url;
          }
        } else {
          const result = await this.removeGitWrapProductFromCart();
          this.form.submit();
        }
      }
      this.submitButton.setAttribute('disabled', true);
    });

    this.giftWrapMessage.addEventListener('input', () => {
      this.updateCounter();
    });

    this.updateCounter();

    this.addGiftWrapButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.openGiftWrapFlyout();
    });

    this.cartFlyoutGiftWrapClose.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeGiftWrapFlyout();
    });
    this.giftProducts.forEach(item => {
      item.addEventListener('keypress', e => {
        if (e.code == 'Enter') {
          const radioInput = item.querySelector('input[type="radio"]');
          radioInput.click();
        }
      });
    });
  }

  openGiftWrapFlyout(e) {
    this.cartFlyoutFooter.classList.add('hidden');
    this.cartFlyoutItems.classList.add('hidden');
    this.cartFlyoutGiftWrap.classList.remove('hidden');
    this.cartFlyoutWrapper.classList.add('open-gift-wrap');
  };

  closeGiftWrapFlyout(e) {
    this.cartFlyoutFooter.classList.remove('hidden');
    this.cartFlyoutItems.classList.remove('hidden');
    this.cartFlyoutGiftWrap.classList.add('hidden');
    this.cartFlyoutWrapper.classList.remove('open-gift-wrap');
  };

  removeEmojiFromGiftMessage() {
    let value = this.giftWrapMessage.value;
    if (this.emojiRegex.test(value)) {
      this.giftWrapMessage.value = value.replace(this.emojiRegex, '');
    }
  }

  updateCounter() {
    const maxLength = this.giftWrapMessage.attributes.maxLength.value || 200;
    this.giftWrapMessageCounter.textContent = `${this.giftWrapMessage.value.length}/${maxLength}`;
  }

  disconnectedCallback() {

  }

  getAddingGiftWrapProductId() {
    const giftWrapProductSelected = this.form.querySelector('input[name=id]:checked');
    if (giftWrapProductSelected) {
      return giftWrapProductSelected.value;
    }
    return null;
  }


  getGiftWrapProductInCartId() {
    const giftWrapProductLineItem = document.querySelector('[data-gift-wrap-product-id]');
    if (giftWrapProductLineItem) {
      return giftWrapProductLineItem.getAttribute('data-gift-wrap-product-id');
    }
    return null;
  }

  async updateGiftMessage() {
    const body = JSON.stringify({'attributes': {'Gift Message': this.giftWrapMessage.value }});
    const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    if (!response.ok) throw new Error('Failed to update gift message');
    return await response.json();
  }

  async removeGitWrapProductFromCart() {
    const giftWrapProductInCartId = this.getGiftWrapProductInCartId();
    if (giftWrapProductInCartId) {
      const body = JSON.stringify({ 'id': giftWrapProductInCartId, 'quantity': 0 });
      const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });
      if (!response.ok) throw new Error('Failed to remove gift wrap');
      return await response.json();
    }
    return {};
  }

}

customElements.define('gift-wrap-component', GiftWrapComponent);
